import { Button } from 'components/ui/button';
import {
  DialogTrigger,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogClose,
  DialogDescription,
} from 'components/ui/dialog';
import { ReactNode } from 'react';

const DialogComp = ({ openButton, title, titleDescription, content, accept, cancel }: IDialog) => {
  return (
    <Dialog>
      <DialogTrigger asChild>{openButton || <Button variant="outline">Open dialog</Button>}</DialogTrigger>
      <DialogContent
        className="sm:w-fit sm:max-h-[95%] sm:max-w-[80%] overflow-y-auto"
        onPointerDownOutside={e => {
          e.preventDefault();
        }}
      >
        {title && (
          <DialogHeader>
            <DialogTitle className="mr-2">{title}</DialogTitle>
            {/** Apparently description tags should exist even if left empty */}
            <DialogDescription>{titleDescription}</DialogDescription>
          </DialogHeader>
        )}
        {content && content}
        <DialogFooter className="sm:justify-end">
          {cancel && (
            <DialogClose asChild>
              <Button type="button" variant="secondary" onClick={() => cancel.callback()}>
                Cancel
              </Button>
            </DialogClose>
          )}
          <DialogClose asChild>
            <Button type="button" onClick={() => accept.callback()} disabled={accept.disabled}>
              {accept.text ?? 'Accept'}
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

interface IDialog {
  openButton?: ReactNode;
  title?: string;
  titleDescription?: string;
  content?: ReactNode;
  accept: {
    callback: () => void;
    text?: string;
    disabled?: boolean;
  };
  cancel?: {
    callback: () => void;
  };
}

export default DialogComp;
